export default "__VITE_ASSET__DXj1cyxl__"